import React, { lazy } from 'react';

const TestimonialCarousel = lazy(() => import('./TestimonialCarousel'));
const TestimonialGrid = lazy(() => import('./TestimonialGrid'));
const TestimonialVideo = lazy(() => import('./TestimonialVideo'));

const TestimonialGenerator = ({ component }) => {
  if (component?.layout === 'Carousel') {
    return <TestimonialCarousel component={component} />;
  }
  if (component?.layout === 'Grid') {
    return <TestimonialGrid component={component} />;
  }
  if (component?.layout === 'Video') {
    return <TestimonialVideo component={component} />;
  }
  return null;
};

export default TestimonialGenerator;
